import { photomontage, existingViewpoint } from "./mapData/photoGeoJSON";

export const generalConfig = {
  googleTranslate: {
    enabled: true,
    languages: [
      { text: "لغة", code: "ar" },
      { text: "语言", code: "zh-CN" },
      { text: "Γλώσσα", code: "el" },
      { text: "Linguaggio", code: "it" },
      { text: "언어", code: "ko" },
      { text: "Ngôn ngữ", code: "vi" },
    ],
  },
};

export const mapConfig = {
  commonLegend: [],
  geocoderConfig: {
    moduleComponentName: "MapboxGeocoder",
    searchBoundary: {
      minX: 140.334286,
      minY: -35.300119,
      maxX: 143.257454,
      maxY: -32.901623,
    },
  },
  icons: [
    {
      id: "ocp-custom-camera-viewpoint-icon-mapbox",
      fileName: "camera-viewpoint.png",
    },
    {
      id: "ocp-custom-camera-photomontage-icon-mapbox",
      fileName: "camera-photomontage.png",
    },
  ],
  layerControls: [
    {
      ids: ["towns-labels"],
      label: "Towns",
    },
    {
      ids: ["roads", "highways"],
      label: "Roads",
    },
    {
      ids: ["cadastre"],
      label: "Cadastre",
    },
    {
      ids: ["waterways-label", "waterways", "waterbody"],
      label: "Waterways",
    },
    {
      ids: ["10m-contour", "2m-contour"],
      label: "Contours/LIDAR/Elevation profile",
    },
    {
      ids: ["existing-transmission-line-infrastructure"],
      label: "Existing transmission line infrastructure",
    },
    {
      ids: ["sensitive-receivers-layer"],
      label: "Sensitive receivers",
    },
    {
      ids: [
        "transmission-line-corridor",
        "proposal-study-area",
        "substation",
        "main-construction-compound-and-accommodation-camps",
      ],
      label: "Project features",
    },
  ],
  layers: [
    {
      id: "photo-points-viewpoint",
      type: "symbol",
      source: {
        type: "geojson",
        data: existingViewpoint,
      },
      layout: {
        "icon-image": "ocp-custom-camera-viewpoint-icon-mapbox",
        "icon-allow-overlap": true,
        "icon-size": 0.4,
      },
    },
    {
      id: "photo-points-photomontage",
      type: "symbol",
      source: {
        type: "geojson",
        data: photomontage,
      },
      layout: {
        "icon-image": "ocp-custom-camera-photomontage-icon-mapbox",
        "icon-allow-overlap": true,
        "icon-size": 0.4,
      },
    },
    {
      id: "lep-heritage-labels",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "LEPHeritage-b64u0e",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.86wj1yd9",
      },
    },
    {
      id: "towns-labels",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Towns-5g2uhp",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.dmbf832j",
      },
    },
    {
      id: "waterways-label",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Watercourse-93eejk",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2rikhq8v",
      },
    },
    {
      id: "substation",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "ExistingSubstations-62sanh",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.a09y5c5e",
      },
    },
    {
      id: "sensitive-receivers-layer",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "SensitiveReceivers-5p6adu",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2qo7lx6k",
      },
    },
    {
      id: "groundwater-bores",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "GWBores-0ef3zq",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.8lwv8ea3",
      },
    },
    {
      id: "previously-unrecorded-her",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "previously-unrecorded-her-4bq534",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.224nlci4",
      },
    },
    {
      id: "threatened-flora-wsp",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "threatened_flora_wsp-72w052",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.bfy964x9",
      },
    },
    {
      id: "threatened-fauna-wsp",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "threatened_fauna_wsp-bfunxk",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.14ckr1v7",
      },
    },
    {
      id: "threatened-fauna-bionet",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "threatened_fauna_bionet-b0efq6",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.5d04ayc0",
      },
    },
    {
      id: "threatened-species-sighting",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "threatened-species-sighting-0ufywt",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.031girzi",
      },
    },
    {
      id: "threatened-fauna-survey",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "threatened-fauna-survey-dt09we",
      type: "symbol",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.226hmt3w",
      },
    },
    {
      id: "fish-habitat",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "fish-habitat-8h75bw",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.4ot4xa9u",
      },
    },
    {
      id: "ahims-sites",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "AHIMSSites_Point-8rw07f",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.a9bdxwop",
      },
    },
    {
      id: "aboriginal-sites-previously-unrecorded",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "AboriginalSites_PrevUnrecorde-8d9fnc",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.5h8n7od2",
      },
    },
    {
      id: "lep-heritage",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "LEPHeritage-b64u0e",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.86wj1yd9",
      },
    },
    {
      id: "non-aboriginal-heritage-points",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "NonAboriginalHeritage_Points-85jlk7",
      type: "circle",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.6l7v6pvl",
      },
    },
    {
      id: "proposal-study-area",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "proposal-study-area-cfd1sl",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.bwps0b2q",
      },
    },
    {
      id: "existing-transmission-line-infrastructure",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "ExistingTransmissionLines-8b3h30",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.6mqa6wki",
      },
    },
    {
      id: "10m-contour",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "Contour10m-7n0bo7",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.7pxzjtj4",
      },
    },
    {
      id: "2m-contour",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "Contour2m-0gf7yv",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2q8uutxh",
      },
    },
    {
      id: "haulage-routes",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "haulage-bsfccw",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.9rwsxawa",
      },
    },
    {
      id: "roads",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Roads-6kvrhi",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.a6sksq66",
      },
    },
    {
      id: "highways",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Highway-16m8vi",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.br67jkqq",
      },
    },
    {
      id: "waterways",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Watercourse-93eejk",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2rikhq8v",
      },
    },
    {
      id: "cadastre",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Cadastre-a0mmcl",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.aeulust9",
      },
    },
    {
      id: "noise-operation-audiblenoisezones",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "operations-audible-noise-20o1ep",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.8kl1ydbh",
      },
    },
    {
      id: "noise-construction-strandardhours",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "Noise_Con_SH-3aw8y3",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.7wlddvk8",
      },
    },
    {
      id: "noise-construction-outofhours-day",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "Noise_Con_OOHDay-8s229z",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.4t3axh7w",
      },
    },
    {
      id: "noise-construction-outofhours-night",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "Noise_Con_OOHNight-3yzngc",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.bxqg74pe",
      },
    },
    {
      id: "noise-operation-burongass-night",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "burong-night-ops-1uiysm",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.4gwjime5",
      },
    },
    {
      id: "noise-operation-burongass-day",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "burong-day-ops-noise-5isff9",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.dn8za6dc",
      },
    },
    {
      id: "disturbance-500m-buffer",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "disturbance-500m-buffer-4z80j4",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.6wb7y52i",
      },
    },
    {
      id: "ibra-regions",
      mapboxStyle: "mapbox://styles/energyconnect/ckgu4rat503eq1ao0riz0plxt",
      "source-layer": "IBRASubRegions-9az885",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.3ampqv44",
      },
    },
    {
      id: "historically-significant-her-border",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "historically-significant-her-6zz76s",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.bynqqkw3",
      },
    },
    {
      id: "historically-significant-her",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "historically-significant-her-6zz76s",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.bynqqkw3",
      },
    },
    {
      id: "realignment-section-of-transmission-line-0x2",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "realignment-section-99l3jx",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.49opv91e",
      },
    },
    {
      id: "decommissioning-of-existing-line-0x1",
      mapboxStyle: "mapbox://styles/energyconnect/ckgafakab0gwg19odwxlmdr4p",
      "source-layer": "DecommissionedLine-22ak5k",
      type: "line",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.6yicsjvp",
      },
    },
    {
      id: "main-construction-compound-and-accommodation-camps",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "camp-accom-construction-crh7pj",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.9e2krgc9",
      },
    },
    {
      id: "transmission-line-corridor",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "trans-line-corr-8c9vkq",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.1qss45hk",
      },
    },
    {
      id: "sandhill-pine-ebc",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "sandhill-pine-ebc-a09e9q",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2q7xt3rf",
      },
    },
    {
      id: "native-vegetation",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "native-vegetation-cohe4v",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.ay2q8imn",
      },
    },
    {
      id: "ramsar-wetland",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "ramsar_wetland-cwxh0e",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.7p6bbr75",
      },
    },
    {
      id: "mnes-habitat-target-species",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "mnes_habitat_target_species-8tj0fr",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.7n1wlx0c",
      },
    },
    {
      id: "fauna-strata",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "fauna-strata-c43duo",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.67j5vfmy",
      },
    },
    {
      id: "native-veg-cover-500m",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "native-veg-cover-500m-0wcy2p",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.6ekdz3wt",
      },
    },
    {
      id: "mitchell-landscapes",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaijr6h3bms19o6m9vppq42",
      "source-layer": "mitchell-landscapes-6ze0g5",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.7qhrriaw",
      },
    },
    {
      id: "gde-terrestrial",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "gde-terrestrial-39lpbr",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.du4tgb85",
      },
    },
    {
      id: "gde-subterranean",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "gde-subterranean-cjki7z",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.cs2e9rgq",
      },
    },
    {
      id: "waterbody",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaex69g0kuo19phkvc9j957",
      "source-layer": "Waterbody-33fseu",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.963fhb92",
      },
    },
    {
      id: "soil-fertility",
      mapboxStyle: "mapbox://styles/energyconnect/ckgahauhh30gd1bluvll7qro9",
      "source-layer": "SoilFertility_2-a1daw8",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.2ipkqyvo",
      },
    },
    {
      id: "hf-flooding",
      mapboxStyle: "mapbox://styles/energyconnect/ckgaddhz80bru19l6j6h93a7s",
      "source-layer": "flood-depths-5fgwo5",
      type: "fill",
      source: {
        type: "vector",
        url: "mapbox://energyconnect.44u0g2e5",
      },
    },
    {
      id: "alternate-satellite-imagery",
      type: "raster",
      source: {
        type: "raster",
        tiles: [
          "https://maps1.six.nsw.gov.au/arcgis/rest/services/sixmaps/LPI_Imagery_Best/MapServer/tile/{z}/{y}/{x}",
          "https://maps2.six.nsw.gov.au/arcgis/rest/services/sixmaps/LPI_Imagery_Best/MapServer/tile/{z}/{y}/{x}",
          "https://maps3.six.nsw.gov.au/arcgis/rest/services/sixmaps/LPI_Imagery_Best/MapServer/tile/{z}/{y}/{x}",
          "https://maps4.six.nsw.gov.au/arcgis/rest/services/sixmaps/LPI_Imagery_Best/MapServer/tile/{z}/{y}/{x}",
        ],
        tileSize: 256,
        minzoom: 4,
        maxzoom: 18,
        attribution: "© Department Finance, Services and Innovation",
      },
      paint: {
        "raster-opacity": 0.8,
      },
    },
  ],
  layerLegends: {
    substation: [
      {
        legendType: "fill",
        colour: "#fa681e",
        outline: "#613500",
        circle: true,
        text: "Buronga substation",
        value: "solid",
      },
      {
        legendType: "fill",
        colour: "#c313c9",
        outline: "#570055",
        circle: true,
        text: "Red Cliffs substation (out of scope)",
        value: "solid",
      },
    ],
    "proposal-study-area": [
      {
        legendType: "icon",
        colour: "#0222ed",
        text: "Proposal study area",
        value: "Square",
      },
    ],
    "main-construction-compound-and-accommodation-camps": [
      {
        legendType: "icon",
        colour: "#0df81c",
        text: "Main construction compounds and accommodation sites",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#78098b",
        text: "Proposed substation upgrade and expansion area",
        value: "SquareFill",
      },
    ],
    "transmission-line-corridor": [
      {
        legendType: "icon",
        colour: "#b8fca1",
        text: "330kV transmission line corridor",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#f9ff42",
        text: "220kV transmission line corridor",
        value: "SquareFill",
      },
    ],
    "sensitive-receivers-layer": [
      {
        legendType: "icon",
        colour: "#f4741f",
        text: "Sensitive Receivers",
        value: "CircleFill",
      },
    ],
    "existing-transmission-line-infrastructure": [
      {
        legendType: "line",
        colour: "#342d2d",
        text: "Existing transmission line infrastructure",
        value: "dotted",
      },
    ],
    "10m-contour": [
      {
        legendType: "line",
        colour: "#feefd2",
        text: "10m contour",
        value: "solid",
      },
    ],
    "2m-contour": [
      {
        legendType: "line",
        colour: "#fcdca1",
        text: "2m contour",
        value: "solid",
      },
    ],
    roads: [
      {
        legendType: "line",
        colour: "#515961",
        text: "Roads",
        value: "solid",
      },
      {
        legendType: "line",
        colour: "#8a8a8a",
        text: "Highway",
        value: "solid",
      },
    ],
    cadastre: [
      {
        legendType: "icon",
        colour: "#c7c7c7",
        text: "Cadastre",
        value: "Square",
      },
    ],
    waterways: [
      {
        legendType: "icon",
        colour: "#7ab6f5",
        text: "Waterways",
        value: "SquareFill",
      },
    ],
    waterbody: [
      {
        legendType: "fill",
        colour: "#7ab6f5",
        outline: "#0040e0",
        text: "Waterbody",
        value: "solid",
      },
    ],
    "photo-points-viewpoint": [
      {
        legendType: "img",
        colour: "",
        text: "Existing viewpoint",
        value: "camera-viewpoint-legend",
      },
    ],
    "photo-points-photomontage": [
      {
        legendType: "img",
        colour: "",
        text: "Photomontages",
        value: "camera-photomontage-legend",
      },
    ],
    "groundwater-bores": [
      {
        legendType: "icon",
        colour: "#0b3ab1",
        text: "Groundwater bores",
        value: "CircleFill",
      },
    ],
    "threatened-flora-wsp": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Threatened flora (WSP)",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "#55ff00",
        text: "Atriplex infrequens",
        value: "CircleFill",
      },
    ],
    "threatened-fauna-wsp": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Threatened fauna (WSP)",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 76, 0)",
        text: "Regent Parrot",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Malleefowl mound",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(169, 0, 230)",
        text: "Corben's Long-eared Bat",
        value: "PentagonFill",
      },
    ],
    "threatened-fauna-bionet": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Threatened fauna (Bionet)",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Corben's Long-eared Bat",
        value: "PentagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 197, 255)",
        text: "Grey Falcon",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(223, 115, 255)",
        text: "Malleefowl",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 0, 0)",
        text: "Painted Honeyeater",
        value: "HexagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Regent Parrot (eastern subspecies)",
        value: "SquareFill",
      },
    ],
    "threatened-species-sighting": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Threatened flora individuals located during survey",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 168, 132)",
        text: "Acacia acanthoclada",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 56, 0)",
        text: "Atriplex infrequens",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(169, 0, 230)",
        text: "Austrostipa nullanulla",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Dodonaea stenozyga",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(76, 230, 0)",
        text: "Santalum murrayanum",
        value: "CircleFill",
      },
    ],
    "threatened-fauna-survey": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Threatened fauna identified during survey",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Black-breasted Buzzard",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Bolam's Mouse",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Chestnut Quail-thrush",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Corben's Long-eared Bat",
        value: "PentagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Dusky Woodswallow",
        value: "HexagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 255, 0)",
        text: "Greater Sand Plover",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 255, 0)",
        text: "Grey-crowned Babbler",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 255, 0)",
        text: "Hooded Robin",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 255, 0)",
        text: "Inland Forest Bat",
        value: "PentagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 255, 0)",
        text: "Little Eagle",
        value: "HexagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Little Pied Bat",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Major Mitchell's Cockatoo",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Malleefowl mound",
        value: "TriangleFill",
      },
      {
        legendType: "img",
        text: "Pectoral Sandpiper",
        value: "pectoral-sandpiper-legend",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Rainbow Bee-eater",
        value: "PentagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 92, 230)",
        text: "Red-necked Stint",
        value: "HexagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Redthroat",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Regent Parrot",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Sharp-tailed Sandpiper",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Southern Ningaui",
        value: "PentagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 255, 0)",
        text: "Spinifex Slender Blue-tongue",
        value: "HexagonFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 0, 0)",
        text: "Superb Parrot",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 0, 0)",
        text: "White-bellied Sea-Eagle",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 0, 0)",
        text: "White-fronted Chat",
        value: "TriangleFill",
      },
    ],
    "fish-habitat": [
      {
        legendType: "line",
        colour: "rgb(0, 255, 197)",
        text: "Fish habitat",
        value: "solid",
      },
    ],
    "ahims-sites": [
      {
        legendType: "icon",
        colour: "#c7a8c4",
        text: "AHIMS sites",
        value: "CircleFill",
      },
    ],
    "aboriginal-sites-previously-unrecorded": [
      {
        legendType: "fill",
        colour: "#3c1137",
        outline: "#f2f2f2",
        circle: true,
        text: "Aboriginal sites previously unrecorded",
        value: "solid",
      },
    ],
    "previously-unrecorded-her": [
      {
        legendType: "icon",
        colour: "rgb(115, 255, 223)",
        text: "Survey marker (Navin Officer Heritage Consultants)",
        value: "TriangleFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 56, 0)",
        text: "LEP historic building",
        value: "CircleFill",
      },
    ],
    "historically-significant-her": [
      {
        legendType: "img",
        text: "Historically significant natural landscape",
        value: "historically-significant-her-legend",
      },
    ],
    "lep-heritage": [
      {
        legendType: "fill",
        colour: "#e4ea3e",
        outline: "#121212",
        text: "LEP Heritage",
        value: "solid",
      },
    ],
    "non-aboriginal-heritage-points": [
      {
        legendType: "fill",
        colour: "#ffffff",
        outline: "#78216f",
        circle: true,
        text: "Non-Aboriginal heritage points",
        value: "solid",
      },
    ],
    "haulage-routes": [
      {
        legendType: "line",
        colour: "#000000",
        text: "Local haulage routes",
        value: "solid",
      },
    ],
    "noise-operation-audiblenoisezones": [
      {
        legendType: "icon",
        colour: "#3a53f2",
        text:
          "Audible noise buffer compliant to PNTL at 442 metres from transmission lines centerline",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#e59215",
        text:
          "Audible noise buffer compliant to PNTL at 548 metres from transmission lines centerline",
        value: "SquareFill",
      },
    ],
    "noise-construction-strandardhours": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Construction noise buffer",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "#6ee7f7",
        text: "390m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#d70940",
        text: "420m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#d5fa05",
        text: "700m construction noise buffer",
        value: "SquareFill",
      },
    ],
    "noise-construction-outofhours-day": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Construction noise buffer",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "#9ee6f0",
        text: "565m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#a80592",
        text: "605m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#fec581",
        text: "1010m construction noise buffer",
        value: "SquareFill",
      },
    ],
    "noise-construction-outofhours-night": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Construction noise buffer",
        value: "CircleFill",
      },
      {
        legendType: "icon",
        colour: "#fdc9f1",
        text: "815m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#b10606",
        text: "875m construction noise buffer",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#fcfbb5",
        text: "1430m construction noise buffer",
        value: "SquareFill",
      },
    ],
    "noise-operation-burongass-night": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Typical night Leq15min",
        value: "Square",
      },
      {
        legendType: "icon",
        colour: "#f7e7f8",
        text: "25-30",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#e2a6e8",
        text: "30-35",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#c36ccb",
        text: "35-40",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#5d1763",
        text: "40-65",
        value: "SquareFill",
      },
    ],
    "noise-operation-burongass-day": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Typical day Leq15min",
        value: "Square",
      },
      {
        legendType: "icon",
        colour: "#f7e7f8",
        text: "25-30",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#e2a6e8",
        text: "30-35",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#c36ccb",
        text: "35-40",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#5d1763",
        text: "40-65",
        value: "SquareFill",
      },
    ],
    "disturbance-500m-buffer": [
      {
        legendType: "fill",
        colour: "rgba(0, 0, 0, 0)",
        outline: "rgb(0, 38, 115)",
        text: "500m disturbance area buffer",
        value: "dashed",
      },
    ],
    "ibra-regions": [
      {
        legendType: "fill",
        colour: "rgba(0, 0, 0, 0)",
        outline: "rgb(168, 0, 0)",
        text: "IBRA regions",
        value: "dashed",
      },
    ],
    "realignment-section-of-transmission-line-0x2": [
      {
        legendType: "line",
        colour: "#b922ec",
        text:
          "Proposed realignment of the existing 220kV transmission line (Line 0X2)",
        value: "dotted",
      },
    ],
    "decommissioning-of-existing-line-0x1": [
      {
        legendType: "line",
        colour: "#cd1335",
        text: "Decommissioning of existing line 0X1 (Buronga to Vic Border)",
        value: "dotted",
      },
    ],
    "ramsar-wetland": [
      {
        legendType: "img",
        text: "Ramsar Wetland",
        value: "ramsar-wetland-legend",
      },
    ],
    "sandhill-pine-ebc": [
      {
        legendType: "icon",
        colour: "rgba(0, 255, 197)",
        text:
          "PCT19 - Cypress Pine woodland of source-bordering dunes mainly on the Murray and Murrumbidgee River floodplains, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgba(132, 0, 168)",
        text:
          "PCT21 - Slender Cypress Pine - Sugarwood - Western Rosewood open woodland on sandy rises mainly in the Riverina Bioregion and Murray Darling Depression Bioregion, modified",
        value: "SquareFill",
      },
    ],
    "mnes-habitat-target-species": [
      {
        legendType: "icon",
        colour: "rgb(255, 211, 127)",
        text: "MNES habitat for target species",
        value: "SquareFill",
      },
    ],
    "fauna-strata": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Fauna strata within the proposal study area",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(85, 255, 0)",
        text: "Arid woodlands/shrublands",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(168, 168, 0)",
        text: "Chenopod shrublands",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 132, 168)",
        text: "Riverine",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(132, 0, 168)",
        text: "Wetland",
        value: "SquareFill",
      },
    ],
    "native-veg-cover-500m": [
      {
        legendType: "icon",
        colour: "rgb(76, 230, 0)",
        text: "Native vegetation cover within 500m of the disturbance area",
        value: "SquareFill",
      },
    ],
    "native-vegetation": [
      {
        legendType: "icon",
        colour: "rgb(255, 235, 175)",
        text:
          "PCT11 - River Red Gum - Lignum very tall open forest or woodland wetland on floodplains of semi-arid (warm) climate zone (mainly Riverina Bioregion and Murray Darling Depression Bioregion), modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 190, 232)",
        text:
          "PCT13 - Black Box - Lignum woodland wetland of the inner floodplains in the semi-arid (warm) climate zone (mainly Riverina Bioregion and Murray Darling Depression Bioregion), derived",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(205, 102, 153)",
        text:
          "PCT13 - Black Box - Lignum woodland wetland of the inner floodplains in the semi-arid (warm) climate zone (mainly Riverina Bioregion and Murray Darling Depression Bioregion), modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(112, 168, 0)",
        text:
          "PCT139 - Prickly Wattle tall open shrubland of dunes and sandplains of semi-arid and arid regions, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(245, 245, 122)",
        text:
          "PCT143 - Narrow-leaved Hopbush - Scrub Turpentine - Senna shrubland on semi-arid and arid sandplains and dunes., modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(223, 115, 255)",
        text:
          "PCT15 - Black Box open woodland wetland with chenopod understorey mainly on the outer floodplains in south-western NSW (mainly Riverina Bioregion and Murray Darling Depression Bioregion), derived",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(132, 0, 168)",
        text:
          "PCT15 - Black Box open woodland wetland with chenopod understorey mainly on the outer floodplains in south-western NSW (mainly Riverina Bioregion and Murray Darling Depression Bioregion), modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(205, 205, 102)",
        text:
          "PCT153 - Black Bluebush low open shrubland of the alluvial plains and sandplains of the arid and semi-arid zones, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(215, 158, 158)",
        text:
          "PCT154 - Pearl Bluebush low open shrubland of the arid and semi-arid plains, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(137, 112, 68)",
        text:
          "PCT159 - Old Man Saltbush shrubland mainly of the semi-arid (warm) climate zone (south western NSW), modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(158, 215, 194)",
        text:
          "PCT166 - Disturbed annual saltbush forbland on clay plains and inundation zones mainly of south-western NSW, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(115, 0, 76)",
        text:
          "PCT17 - Lignum shrubland wetland of the semi-arid (warm) plains (mainly Riverina Bioregion and Murray Darling Depression Bioregion), modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(209, 255, 115)",
        text:
          "PCT170 - Chenopod sandplain mallee woodland/shrubland of the arid and semi-arid (warm) zones, derived",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(76, 230, 0)",
        text:
          "PCT170 - Chenopod sandplain mallee woodland/shrubland of the arid and semi-arid (warm) zones, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(38, 115, 0)",
        text:
          "PCT170 - Chenopod sandplain mallee woodland/shrubland of the arid and semi-arid (warm) zones, modified_bull",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(165, 245, 122)",
        text:
          "PCT170 - Chenopod sandplain mallee woodland/shrubland of the arid and semi-arid (warm) zones, modified_whip",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(209, 191, 90)",
        text:
          "PCT171 - Spinifex linear dune mallee mainly of the Murray Darling Depression Bioregion, modified_bull",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(247, 233, 198)",
        text:
          "PCT171 - Spinifex linear dune mallee mainly of the Murray Darling Depression Bioregion, modified_whip",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(205, 137, 102)",
        text:
          "PCT172 - Deep sand mallee of irregular dunefields of the semi-arid (warm) zone, modified_whip",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(122, 245, 202)",
        text:
          "PCT19 - Cypress Pine woodland of source-bordering dunes mainly on the Murray and Murrumbidgee River floodplains, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(112, 68, 137)",
        text:
          "PCT21 - Slender Cypress Pine - Sugarwood - Western Rosewood open woodland on sandy rises mainly in the Riverina Bioregion and Murray Darling Depression Bioregion, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(115, 38, 0)",
        text:
          "PCT216 - Black Roly Poly low open shrubland of the Riverina Bioregion and Murray Darling Depression Bioregion, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 235, 190)",
        text:
          "PCT221 - Black Oak - Pearl Bluebush open woodland of the sandplains of the semi-arid warm and arid climate zones, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(250, 210, 200)",
        text:
          "PCT252 - Sugarwood open woodland of the inland plains mainly Murray Darling Depression Bioregion, derived",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(240, 55, 58)",
        text:
          "PCT252 - Sugarwood open woodland of the inland plains mainly Murray Darling Depression Bioregion, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(209, 166, 142)",
        text:
          "PCT253 - Gypseous shrubland on rises in the semi-arid and arid plains, modified_boninka",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(247, 130, 57)",
        text:
          "PCT253 - Gypseous shrubland on rises in the semi-arid and arid plains, modified_lunette",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(190, 210, 255)",
        text:
          "PCT58 - Black Oak - Western Rosewood open woodland on deep sandy loams mainly in the Murray Darling Depression Bioregion, derived",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 112, 255)",
        text:
          "PCT58 - Black Oak - Western Rosewood open woodland on deep sandy loams mainly in the Murray Darling Depression Bioregion, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(0, 77, 168)",
        text:
          "PCT58 - Black Oak - Western Rosewood open woodland on deep sandy loams mainly in the Murray Darling Depression Bioregion, modified_whip",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(68, 101, 137)",
        text:
          "PCT63 - 	Spiny Lignum - Slender Glasswort open forbland sailine wetland on lake edges in the semi-arid and arid climate zones, modified",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(102, 96, 107)",
        text: "Miscellaneous/exotic",
        value: "SquareFill",
      },
    ],
    "mitchell-landscapes": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Mitchell landscape",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 190, 232)",
        text: "Lower Darling Alluvial Plains",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(245, 245, 122)",
        text: "Lower Darling Channels and Floodplains",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(255, 127, 127)",
        text: "Mallee Cliffs Dunes",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(137, 137, 68)",
        text: "Mallee Cliffs Linear Dunes",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(230, 152, 0)",
        text: "Mallee Cliffs Sandplains",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(102, 205, 171)",
        text: "Murray Channels and Floodplains",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(170, 102, 205)",
        text: "Murray Lakes, Swamps and Lunettes",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(245, 202, 122)",
        text: "Scotia Groundwater Basins",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(137, 90, 68)",
        text: "Scotia Linear Dunes",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(137, 205, 102)",
        text: "Scotia Sandplains",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "rgb(206, 220, 242)",
        text: "Other",
        value: "SquareFill",
      },
    ],
    "gde-terrestrial": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Terrestrial (aquatic) Ground Dependent Ecosystems",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#b933e6",
        text: "Low potential for GW interaction",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#47f0c3",
        text: "Moderate potential for GW interaction",
        value: "SquareFill",
      },
    ],
    "gde-subterranean": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Subterranean (vegetation) Ground Dependent Ecosystems",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#aefaf6",
        text: "Low potential GDE",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#f2ab54",
        text: "Moderate potential GDE",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#fba2f9",
        text: "High potential GDE",
        value: "SquareFill",
      },
    ],
    "soil-fertility": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text:
          "Estimated soil fertility within and surrounding the proposal study area",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#40a220",
        text: "Moderate",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#f4bc66",
        text: "Moderately low",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#fefab8",
        text: "Low",
        value: "SquareFill",
      },
    ],
    "hf-flooding": [
      {
        legendType: "icon",
        colour: "rgba(0, 0, 0, 0)",
        text: "Existing flooding depths (m)",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#bef6f9",
        text: "<= 0.5m",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#0db5f2",
        text: "0.5m - 1.0m",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#1294f8",
        text: "1.0 - 1.5m",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#093bf1",
        text: "1.5m - 2.0m",
        value: "SquareFill",
      },
      {
        legendType: "icon",
        colour: "#001560",
        text: "> 2.0m",
        value: "SquareFill",
      },
    ],
  },
  mapComponentConfig: {
    moduleComponentName: "Mapbox",
    mapboxStyle: "mapbox://styles/energyconnect/ckgg57uuz5zlr19nxv2rtkk14",
    customAttribution: "Indicative only, subject to design development",
    initialMapState: {
      locationOptions: {
        zoom: 9,
        center: [141.70966, -33.954956],
        pitch: 0,
        bearing: 0,
      },
      resetInitialLocation: false,
      layerOptions: {
        visible: [
          "existing-transmission-line-infrastructure",
          "sensitive-receivers-layer",
          "transmission-line-corridor",
          "proposal-study-area",
          "substation",
          "main-construction-compound-and-accommodation-camps",
        ],
      },
    },
    basemaps: {
      primary: {
        imageName: "primary",
        type: "style",
        id: "mapbox://styles/energyconnect/ckgg57uuz5zlr19nxv2rtkk14",
      },
      alternate: {
        imageName: "alternate",
        type: "layer",
        id: "alternate-satellite-imagery",
      },
    },
  },
  popups: [
    {
      id: "photo-popup-viewpoint",
      layerId: "photo-points-viewpoint",
      mouseEvent: "click",
      featureProps: [
        {
          featureId: "1",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "1-view-east-along-renmark-road",
            lightboxSources: [
              {
                type: "image",
                title: "View East along Renmark Road",
                caption: "View East along Renmark Road",
                fileName: "1-view-east-along-renmark-road",
              },
            ],
          },
        },
        {
          featureId: "4",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "4-view-north-from-lake-victoria-visitor-lookout",
            lightboxSources: [
              {
                type: "image",
                title: "View north from Lake Victoria visitor lookout",
                caption: "View north from Lake Victoria visitor lookout",
                fileName: "4-view-north-from-lake-victoria-visitor-lookout",
              },
            ],
          },
        },
        {
          featureId: "6",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "6-view-south-from-anabranch-mail-road",
            lightboxSources: [
              {
                type: "image",
                title: "View south from Anabranch Mail Road",
                caption: "View south from Anabranch Mail Road",
                fileName: "6-view-south-from-anabranch-mail-road",
              },
            ],
          },
        },
        {
          featureId: "8",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "8-view-from-pooncarrie-road",
            lightboxSources: [
              {
                type: "image",
                title: "View from Pooncarrie Road",
                caption: "View from Pooncarrie Road",
                fileName: "8-view-from-pooncarrie-road",
              },
            ],
          },
        },
        {
          featureId: "9",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "9-view-northeast-from-arumpo-road",
            lightboxSources: [
              {
                type: "image",
                title: "View northeast from Arumpo Road",
                caption: "View northeast from Arumpo Road",
                fileName: "9-view-northeast-from-arumpo-road",
              },
            ],
          },
        },
      ],
    },
    {
      id: "photo-popup-photomontage",
      layerId: "photo-points-photomontage",
      mouseEvent: "click",
      featureProps: [
        {
          featureId: "2",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "2-view-north-from-track-to-lake-victoria",
            lightboxSources: [
              {
                type: "image",
                title: "View north from track to Lake Victoria",
                caption:
                  "View north from track to Lake Victoria - indicative only",
                fileName: "2-view-north-from-track-to-lake-victoria",
              },
            ],
          },
        },
        {
          featureId: "3",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "3-view-north-from-track-near-lake-victoria",
            lightboxSources: [
              {
                type: "image",
                title: "View north from track near Lake Victoria",
                caption:
                  "View north from track near Lake Victoria - indicative only",
                fileName: "3-view-north-from-track-near-lake-victoria",
              },
            ],
          },
        },
        {
          featureId: "5",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName:
              "5-view-north-from-renmark-road-near-intersection-with-nulla-road",
            lightboxSources: [
              {
                type: "image",
                title:
                  "View north from Renmark Road near intersection with Nulla Road",
                caption:
                  "View north from Renmark Road near intersection with Nulla Road - indicative only",
                fileName:
                  "5-view-north-from-renmark-road-near-intersection-with-nulla-road",
              },
            ],
          },
        },
        {
          featureId: "7",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "7-view-south-from-silver-city-highway",
            lightboxSources: [
              {
                type: "image",
                title: "View south from Silver City Highway",
                caption:
                  "View south from Silver City Highway - indicative only",
                fileName: "7-view-south-from-silver-city-highway",
              },
            ],
          },
        },
        {
          featureId: "10",
          moduleComponentName: "Thumbnail",
          moduleProps: {
            columnProps: { className: "p-0" },
            startingLightboxIndex: 0,
            isOpaqueUntilHover: false,
            fileName: "10-view-southeast-from-sturt-highway",
            lightboxSources: [
              {
                type: "image",
                title: "View southeast from Sturt Highway",
                caption: "View southeast from Sturt Highway - indicative only",
                fileName: "10-view-southeast-from-sturt-highway",
              },
            ],
          },
        },
      ],
    },
  ],
  sites: [
    {
      id: "burongaSubstation",
      label: "Buronga Substation",
      locationOptions: {
        zoom: 14,
        center: [142.258419, -34.102136],
        pitch: 0,
        bearing: 0,
      },
    },
    {
      id: "anabranchSouthCamp",
      label: "Anabranch South Camp",
      locationOptions: {
        zoom: 14,
        center: [141.792152, -33.854421],
        pitch: 0,
        bearing: 0,
      },
    },
    {
      id: "BurongaCamp",
      label: "Buronga Camp",
      locationOptions: {
        zoom: 14,
        center: [142.251064, -34.105162],
        pitch: 0,
        bearing: 0,
      },
    },
    {
      id: "proposedRealignment",
      label:
        "Proposed realignment of the existing 220kV transmission line (Line 0X2)",
      locationOptions: {
        zoom: 16,
        center: [141.990962, -33.854324],
        pitch: 0,
        bearing: 0,
      },
    },
    {
      id: "decomissionLine",
      label: "Decommissioning of existing line 0X1 (Buronga to Vic Border)",
      locationOptions: {
        zoom: 11,
        center: [142.281975, -34.185692],
        pitch: 0,
        bearing: 0,
      },
    },
  ],
};

export const navConfig = {
  items: {
    nonCollapsing: [
      {
        item: "logo",
        filename: "transgridColour",
        linkProps: {
          path: "https://transgrid.com.au/energyconnect",
          isExternal: true,
        },
      },
    ],
    collapsing: [
      {
        item: "modal-button",
        text: "Make a Submission",
        modalId: "make-a-submission",
      },
    ],
  },
};

export const footerConfig = {
  leftContent: {
    copyrightText: "© 2020 WSP",
  },
};
